import { IFsFileType } from "@r3f-component-data-structure";
import { Texture } from "three";
import { FsBaseFile } from "./base";

export class FsImage extends FsBaseFile {
    type: IFsFileType.Image | IFsFileType.Image360 | IFsFileType.ImageTarget = IFsFileType.Image
    /**
     * Object key under `proj-<id>/<fileId>/` holding the bytes — the same thing store.ts's
     * PROJECT_FILE_KEY_BY_TYPE maps. A subclass overriding it must recompute `_objectUrl` in its own
     * constructor: field initialisers run after `super()`, so the value read here is still this one.
     */
    protected _objectKey = 'img'
    protected _objectUrl: string
    private _texture: Texture | undefined

    constructor(fileId: string, projectId: string, name: string) {
        super(fileId, projectId, name)
        const url = new URL(this.baseUrl)
        url.pathname = `${url.pathname}/${this._objectKey}`
        this._objectUrl = url.toString()
    }

    async getUrl() {
        return this.fs.getBlobUrl(this._objectUrl, await this.getBlob())
    }

    async getBlob() {
        return this.fs.getObjectBlob(this._objectUrl)
    }

    async createImageBitmap() {
        return createImageBitmap(await this.getBlob())
    }

    async getAspectRatio() {
        const img = await this.createImageBitmap()
        if (img.height === 0) return 1
        return img.width / img.height
    }

    async getTexture() {
        if (typeof this._texture === 'undefined') {
            const blob = await this.getBlob()
            this._texture = new Texture();
            this._texture.image = await createImageBitmap(blob, {imageOrientation: 'flipY'})
            this._texture.needsUpdate = true;
        }
        return this._texture
    }

    getBundlerPath() {
        return `fs/${this.id}/${this._objectKey}`
    }

    async getFilesForBundler(): Promise<{
        path: string;
        bin: Uint8Array<ArrayBuffer| ArrayBufferLike>;
    }[]> {
        const blob = await this.getBlob()
        return [{
            path: this.getBundlerPath(),
            bin: new Uint8Array(await blob.arrayBuffer())
        }]
    }
}
